import React, { useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { Spinner, Text, VStack } from "@chakra-ui/react";

interface PayPalButtonProps {
  price: number; // Price of the selected print
  onSuccess: (details: any) => void; // Callback after successful payment
  onError?: (error: any) => void; // Callback for errors
}

const PayPalButton: React.FC<PayPalButtonProps> = ({ price, onSuccess, onError }) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleApprove = (orderID: string) => {
    setIsProcessing(true);
    onSuccess(orderID); // Notify parent about the success - parent will handle redirect
  };

  return (
    <PayPalScriptProvider
      options={{
        clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID || "",
        currency: "EUR",
        locale: "es_ES",
        intent: "capture"
      }}
    >
      {isProcessing ? (
        <VStack spacing={3} p={4}>
          <Spinner size="lg" />
          <Text>Processing your payment and preparing downloads...</Text>
        </VStack>
      ) : (
        <PayPalButtons
          style={{ layout: "vertical" }}
          createOrder={(data, actions) => {
            return actions.order.create({
              intent: "CAPTURE", // Set intent to CAPTURE for immediate payment
              purchase_units: [
                {
                  amount: {
                    currency_code: "EUR", // Add currency_code
                    value: price.toString(), // Convert price to a string
                  },
                },
              ],
            });
          }}
          onApprove={(data, actions) => {
            return actions!.order!.capture().then((details) => {
              if (details.id) {
                handleApprove(details.id); // Notify on approval
              } else {
                console.error("Order ID is missing in payment details.");
              }
            });
          }}
          onError={(err) => {
            console.error("PayPal Checkout Error", err);
            setError("Something went wrong with your payment.");
            if (onError) onError(err);
          }}
        />
      )}
      {error && <div style={{ color: "red" }}>{error}</div>}
    </PayPalScriptProvider>
  );
};

export default PayPalButton;
